// extracted by mini-css-extract-plugin
export var filterIncDec = "_em-0";
export var leftBorder = "_em-1";
export var rightBorder = "_em-2";
export var stringInput = "_em-3";